<template>
  <div class="sp_createUser">
    <el-dialog :title="userMsg.title"
               :visible="userMsg.show"
               width="640PX"
               :before-close="handleClose"
               :close-on-click-modal="false">
      <el-form :model="userForm"
               ref="userForm"
               class="creat-user-form"
               :rules="userRules">
        <el-form-item class="flex-item"
                      label="First Name："
                      prop="firstName">
          <el-input type="text"
                    v-model="userForm.firstName"
                    size="medium"
                    placeholder="Please input first name"></el-input>
        </el-form-item>
        <el-form-item class="flex-item"
                      label="Last Name："
                      prop="lastName">
          <el-input type="text"
                    v-model="userForm.lastName"
                    size="medium"
                    placeholder="Please input last name"></el-input>
        </el-form-item>
        <el-form-item class="flex-item"
                      label="Email："
                      prop="email">
          <el-input :disabled="userMsg.title == 'Edit'"
                    type="text"
                    v-model="userForm.email"
                    size="medium"
                    placeholder="Please input email"></el-input>
        </el-form-item>
        <el-form-item class="flex-item"
                      label="Phone："
                      prop="phone">
          <el-input type="number"
                    class="input-with-select"
                    v-model="userForm.phone"
                    size="medium"
                    placeholder="Please input phone">
            <el-select filterable
                       size="small"
                       no-match-text="No Data"
                       remote
                       :remote-method="remoteMethod"
                       @visible-change="areaCodeFocus"
                       v-model="userForm.areaCode"
                       slot="prepend"
                       placeholder="Code">
              <el-option :label="val.areaCode"
                         :value="val.id"
                         v-for="val in areaCodelist"
                         :key="val.id">{{val.country+' '+val.areaCode}}</el-option>
            </el-select>
          </el-input>
        </el-form-item>
        <el-form-item class="flex-item"
                      label="Role："
                      prop="role">
          <el-select v-model="userForm.role"
                     placeholder="Please select role"
                     size="small"
                     style="width:100%;"
                     :disabled="$store.state.user.userInfo.roleId!=='1'||userMsg.row.id==$store.state.user.userInfo.id">
            <el-option v-for="val in roleInfoList"
                       :label="val.name"
                       :key="val.id"
                       :value="val.id"
                       :disabled="val.id==1&&userMsg.title=='Create'"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="flex-item"
                      label="Status："
                      prop="status">
          <el-select v-model="userForm.status"
                     placeholder="Please select status"
                     size="small"
                     style="width:100%;"
                     :disabled="$store.state.user.userInfo.roleId!=='1'||userMsg.row.id==$store.state.user.userInfo.id">
            <el-option label="Enabled"
                       :value="0"></el-option>
            <el-option label="Disabled"
                       :value="1"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer"
            class="dialog-footer">
        <el-button class="btn"
                   type="primary"
                   @click="handelCreate('userForm')"
                   size="medium"
                   :loading="saveLoading">OK</el-button>
        <el-button class="btn"
                   @click="handleClose"
                   size="medium">Cancel </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { createUserApi, updateUserApi } from '@/api/userApi.js'
import { checkHavetEmail } from '@/api/loginApi.js'
import { registerEncrypt } from '@/utils/encrypt.js'
export default {
  name: 'createUser',
  props: {
    userMsg: {
      type: Object,
      required: true,
      default: () => {},
    },
    roleInfoList: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  data() {
    var checkFirstName = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('Please input first name'))
      } else {
        if (value.length > 255) {
          return callback(new Error('Cannot exceed over 255 characters.'))
        } else {
          callback()
        }
      }
    }
    var checkLastName = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('Please input last name'))
      } else {
        if (value.length > 255) {
          return callback(new Error('Cannot exceed over 255 characters.'))
        } else {
          callback()
        }
      }
    }
    var checkEmail = (rule, value, callback) => {
      const Reg =
        /^([a-zA-Z0-9_+-.])+@([a-zA-Z0-9_+-])+((\.[a-zA-Z0-9_-]{2,20}){1,4})$/
      if (!value) {
        return callback(new Error('Please input email'))
      } else {
        if (Reg.test(value)) {
          if (value.length > 255) {
            return callback(new Error('Cannot exceed over 255 characters.'))
          } else {
            if (value == this.userMsg.row.email) {
              return callback()
            } else {
              checkHavetEmail(registerEncrypt(value)).then((res) => {
                if (res.code == 500) {
                  return callback()
                } else {
                  return callback(
                    new Error('The email address has been registered')
                  )
                }
              })
            }
          }
        } else {
          return callback(
            new Error(
              'Your email format is wrong, please check and try it again.'
            )
          )
        }
      }
    }
    var checkPhone = (rule, value, callback) => {
      if (value && this.userForm.areaCode !== '') {
        return callback()
      } else if (value.length > 255) {
        return callback(new Error('Cannot exceed over 255 characters.'))
      } else {
        return callback(new Error('Please input the phone number.'))
      }
    }
    return {
      userForm: {
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        areaCode: '',
        role: '',
        status: 0,
      },
      areaCodelist: [],
      userRules: {
        firstName: [
          { required: true, validator: checkFirstName, trigger: 'blur' },
        ],
        lastName: [
          { required: true, validator: checkLastName, trigger: 'blur' },
        ],
        email: [{ required: true, validator: checkEmail, trigger: 'blur' }],
        phone: [{ required: true, validator: checkPhone, trigger: ['blur'] }],
        role: [
          { required: true, message: 'Please select role', trigger: 'change' },
        ],
        status: [
          {
            required: true,
            message: 'Please select status',
            trigger: 'change',
          },
        ],
      },
      saveLoading: false,
    }
  },

  methods: {
    //关闭页面
    handleClose() {
      this.$emit('userChildMsg', { show: false, isSave: false })
    },

    //创建用户
    handelCreate(userForm) {
      this.$refs[userForm].validate((valid) => {
        if (valid) {
          this.saveLoading = true
          let params = JSON.parse(JSON.stringify(this.userForm))
          if (this.userMsg.title == 'Edit') {
            params.id = this.userMsg.row.id
          }
          if (this.userMsg.title == 'Edit') {
            if (this.userMsg.row.roleId == '2' && params.role == '1') {
              this.$confirm(
                'Are you sure that you want to transfer the administrator to "' +
                  this.userMsg.row.email +
                  '"? You will log out after you click to confirm',
                'Hint',
                {
                  confirmButtonText: 'Confirm',
                  cancelButtonText: 'Cancel',
                  type: 'warning',
                }
              )
                .then(() => {
                  updateUserApi(params)
                    .then((res) => {
                      this.saveLoading = false
                      this.$emit('userChildMsg', { show: false, isSave: true })
                      this.$message({
                        type: 'success',
                        message: 'Save successfully',
                      })
                      setTimeout(() => {
                        this.$store.dispatch('LogOut')
                      }, 1000)
                    })
                    .catch(() => {
                      this.saveLoading = false
                    })
                })
                .catch(() => {
                  this.saveLoading = false
                })
            } else {
              updateUserApi(params)
                .then((res) => {
                  this.saveLoading = false
                  this.$emit('userChildMsg', { show: false, isSave: true })
                  this.$message({
                    type: 'success',
                    message: 'Save successfully',
                  })
                  if (this.userMsg.row.id == this.$store.getters.userInfo.id) {
                    this.$store.dispatch('GetUserInfo')
                  }
                })
                .catch(() => {
                  this.saveLoading = false
                })
            }
          } else {
            createUserApi(params)
              .then((res) => {
                this.saveLoading = false
                this.$emit('userChildMsg', { show: false, isSave: true })
                this.$message({
                  type: 'success',
                  message: 'Save successfully',
                })
              })
              .catch(() => {
                this.saveLoading = false
              })
          }
        }
      })
    },

    //电话区号搜索
    remoteMethod(qurey) {
      this.areaCodelist = this.$ls.get('AreaCode')
      this.areaCodelist = this.areaCodelist.filter((val) => {
        if (
          (val.country + ' ' + val.areaCode)
            .toLowerCase()
            .replace(/\s/g, '')
            .indexOf(qurey.toLowerCase().replace(/\s/g, '')) != -1
        ) {
          return true
        }
        return false
      })
    },
    areaCodeFocus(qurey) {
      setTimeout(() => {
        if (!qurey) {
          this.areaCodelist = this.$ls.get('AreaCode')
        }
      }, 200)
    },
  },

  created() {
    this.areaCodelist = this.$ls.get('AreaCode')
    console.log(this.userMsg)
    console.log(this.$store.state.user.userInfo)
    if (this.userMsg.title == 'Edit') {
      this.userForm.firstName = this.userMsg.row.firstName
      this.userForm.lastName = this.userMsg.row.lastName
      this.userForm.email = this.userMsg.row.email
      this.userForm.phone = this.userMsg.row.phone
        ? this.userMsg.row.phone.replace(/\s/g, '')
        : ''
      this.userForm.areaCode = this.userMsg.row.areaCode
      this.userForm.role = this.userMsg.row.roleId
      this.userForm.status = this.userMsg.row.status
    } else {
      this.userForm.firstName = ''
      this.userForm.lastName = ''
      this.userForm.email = ''
      this.userForm.phone = ''
      this.userForm.areaCode = ''
      this.userForm.role = ''
    }
  },
}
</script>

<style scoped lang="scss">
.creat-user-form {
  padding: 16px 20px 4px 20px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  .el-form-item {
    margin-bottom: 16px;
  }
  .flex-item {
    width: 256px;
  }
}
.btn {
  width: 64px;
}
/deep/.el-dialog__body {
  padding: 0 20px;
}

/deep/.el-form-item__label {
  height: 20px;
  line-height: 20px;
  margin-bottom: 4px;
  font-size: 14px;
  color: #545c66;
}

/deep/.el-form-item__content {
  line-height: 32px;
  width: 256px;
}
/deep/.el-input-group__prepend {
  width: 34%;
  background: #fff;
}

/deep/.el-dialog__footer {
  text-align: right;
  padding: 16px 20px;
}
/deep/.el-select {
  .el-select__caret:first-child::before {
    content: '\e6e1';
  }
  .is-focus {
    .el-select__caret:first-child {
      transform: rotateZ(0deg);
    }
  }
}
/deep/.input-with-select input::-webkit-outer-spin-button,
/deep/.input-with-select input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
/deep/ .input-with-select input[type='number'] {
  -moz-appearance: textfield;
}
.el-form-item.is-required:not(.is-no-asterisk)
  .el-form-item__label-wrap
  > .el-form-item__label:before,
/deep/.el-form-item.is-required:not(.is-no-asterisk)
  > .el-form-item__label:before {
  margin-left: -10px !important;
}
</style>